import { Box, IconButton, Typography, Slide, Button } from "@mui/material";
import { ReactComponent as PenIcon2 } from "../../../Assets/svg/PenIcon2.svg";
import { ReactComponent as ArrowRightIconTransparent } from "../../../Assets/svg/ArrowRightIconTransparent.svg";
// import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });
function UserItem(props) {
    const { userInfo } = props


    useEffect(() => {
        // var time = propInfo.LastModified

        // console.log(moment(moment.unix(propInfo.LastModified).format("jYYYY/jMM/jDD")).fromNow())



    }, [])

    



    return (<>
        <Box className="userItem" sx={{ p: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                    <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px", overflow: "hidden" }}>
                        <img src={userInfo.Avatar ? userInfo.Avatar : './assets/img/User-avatar.svg.png'} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </Box>
                    {!props.isAgency ? <Typography component="span">{userInfo && userInfo.username}</Typography> : <Typography component="span">{userInfo && userInfo.FullName}</Typography>}
                </Box>
                {props.isAgency ? <IconButton onClick={() => props.handleClickOpenEditUserModal(userInfo)}>
                    <PenIcon2 />
                </IconButton> : ""}
            </Box>
            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'end', gap: "5px" }}>
                {!props.isAdmin && <Button sx={{ borderRadius: "50px", bgcolor: '#BDECF3', color: "#18BBD4", stroke: "#18BBD4", display: 'flex', gap: '5px' }} onClick={() => props.handleClickPermissionsModal(userInfo && userInfo.Permissions, userInfo && userInfo)}>
                    مجوز ها
                    <ArrowRightIconTransparent className="x-arrow" />
                </Button>}
                {/* {!props.isAdmin ? <Button sx={{ borderRadius: "50px", bgcolor: userInfo.AccountStatus == "0" ? '#D6ECD2' : '#FEA3A3!important', color: userInfo.AccountStatus == "0" ? "#096767" : "#fff", stroke: "#096767", display: 'flex', gap: '5px' }} onClick={() => props.changeAccountStatus(userInfo.Id,userInfo.Avatar,userInfo.FullName,userInfo.AgencyMobile,userInfo.AccountStatus == "0" ? 1 : 0)}>
                    {userInfo.AccountStatus == "0" ? "فعال کردن" : "غیرفعال کردن"}
                    <ArrowRightIconTransparent className="x-arrow" style={{stroke: userInfo.AccountStatus == "0" ? "" : "#fff"}} />
                </Button> : <Button sx={{ borderRadius: "50px", bgcolor: '#D6ECD2', color: "#096767", stroke: "#096767", display: 'flex', gap: '5px' }}>
                    ارتقا به نسخه حرفه ای
                    <ArrowRightIconTransparent className="x-arrow" />
                </Button>} */}
            </Box>
        </Box>
    </>);
}

export default UserItem;